import moment from 'moment';
// import i18n from '../modules/datetimepicker_i18n.json';

exports.br2nl = (str, replaceMode) => {
  const replaceStr = replaceMode ? '\n' : '';
  // Includes <br>, <BR>, <br />, </br>
  // return str.replace('/<\s*\/?br\s*[\/]?>/gi', replaceStr);
  return str.replace('/<s*/?brs*[/]?>/gi', replaceStr);
};

exports.nl2br = (str, replaceMode, isXhtml) => {
  const breakTag = isXhtml ? '<br />' : '<br>';
  // const replaceStr = replaceMode ? '$1'+ breakTag : '$1'+ breakTag +'$2';
  const replaceStr = replaceMode ? `$1${breakTag}` : `$1${breakTag}$2`;
  return `str`.trim().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
};

exports.getLang = () => {
  const $html = document.querySelector('html');
  const langAttr = $html.getAttribute('lang');
  const lang = langAttr.split('-', 1);

  return lang[0];
};

exports.formatDate = lang => {
  switch (lang) {
    case 'en':
      return moment().format('MM/DD/YYYY');
    // return moment('DD/MM/YYYY');
    case 'fr':
    case 'it':
      return moment().format('DD/MM/YYYY');
    // return moment('YYYY.MM.DD.');
    case 'hu':
      return moment().format('YYYY.MM.DD.');
    // return moment('MM/DD/YYYY');
    case 'de':
    default:
      return moment().format('DD.MM.YYYY');
  }
};



// WEBPACK FOOTER //
// ./src/main/javascripts/lib/str_tool.js